import { useEffect, useState } from "react";
import { useLocale } from "../i18n";
import { BulkTeamAdmissionDialog } from "./BulkTeamAdmissionDialog";
import { CommandForm } from "./CommandForm";
import { ReadPanel } from "./ReadPanel";
import type { Context, RecordValue } from "./types";
import "../styles/season-teams.css";

export function EntryCandidates({ context, actorId, revision, canAdmit, onChanged, onLock }: {
  context: Context; actorId: string; revision: number; canAdmit: boolean; onChanged: () => void; onLock?: (locked: boolean) => void;
}) {
  const { w } = useLocale();
  const [selected, setSelected] = useState<RecordValue>();
  const [locked, setLocked] = useState(false);
  const [chosen, setChosen] = useState<RecordValue[]>([]); const [bulkOpen, setBulkOpen] = useState(false); const [selectionError, setSelectionError] = useState(false);
  useEffect(() => { onLock?.(locked || bulkOpen); return () => onLock?.(false); }, [locked, bulkOpen, onLock]);
  const round = context.unit?.unitKind === "VOTING_ROUND";
  const editable = round && context.unit?.roundState === "DRAFT" && context.unit.status !== "ARCHIVED" && canAdmit && !context.readOnly;
  function choose(rows: RecordValue[]) {
    setSelectionError(false);
    const removing = rows.every(row => chosen.some(item => item.partyId === row.partyId));
    const next = removing ? chosen.filter(item => !rows.some(row => row.partyId === item.partyId)) : [...chosen, ...rows.filter(row => !chosen.some(item => item.partyId === row.partyId))];
    if (next.length > 100) { setSelectionError(true); return; }
    setChosen(next);
  }
  const reloaded = () => { setChosen([]); setBulkOpen(false); onChanged(); };
  return <div className="event-season-teams event-entry-candidates">
    {bulkOpen && <BulkTeamAdmissionDialog teams={chosen} context={context} onClose={() => setBulkOpen(false)} onSaved={reloaded} onReload={reloaded} />}
    {selectionError && <p role="alert">{w("الحد الأقصى 100 فريق في الدفعة. لم يتغير التحديد الحالي.", "A batch can contain up to 100 teams. Your existing selection was kept.")}</p>}
    {selected ? <div className="event-candidate-editor">
      <button type="button" className="text-button" disabled={locked} onClick={() => setSelected(undefined)}>{w("العودة إلى الفرق القابلة للمشاركة", "Back to eligible teams")}</button>
      <p>{w("الفريق المحدد", "Selected team")}: <strong>{String(selected.name)}</strong></p>
      <CommandForm name="roundEntry" title={w("إدراج الفريق في الجولة", "Admit team to round")} context={context} actorId={actorId}
        fixedQuery={{ partyId: selected.partyId, entryId: "" }} fixedBody={{ included: true }} onLock={setLocked} onCancel={() => setSelected(undefined)}
        onChanged={() => { setSelected(undefined); setChosen([]); onChanged(); }} />
    </div> : <ReadPanel name="entryCandidates" title={w("فرق قابلة للمشاركة", "Eligible teams")} context={context} revision={revision}
      onCandidateSelect={editable ? setSelected : undefined}
      teamSelection={editable ? { teams: chosen, onToggle: team => choose([team]), onTogglePage: choose, onReview: () => setBulkOpen(true), onClear: () => { setChosen([]); setSelectionError(false); }, disabled: locked || bulkOpen } : undefined} />}
  </div>;
}
